import { ProductMenu } from '../product-menu';
import { Type } from '@angular/core';
import { MenuHeaderTitleImageComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/menu-header-title/menu-header-title-image/menu-header-title-image.component';
import { ColorUtils } from '../../../utils/color-utils';
import { ProductMenuHeaderComponent } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-header/product-menu-header.component';
import { SectionRowViewModel } from '../../../modules/display/components/menus/product-menu/building-blocks/menu-section/product-section/section-row-view-models/SectionRowViewModel';
import type { SectionWithProducts } from '../section/section-with-products';
import { FONT, FontStyleSheet } from '../font-style-sheets';
import { WithinNameCell } from '../../enum/shared/within-name-cell';

export class ContemporaryMenu extends ProductMenu {
  getThemeClass(): string {
    return 'contemporary-theme';
  }

  getHeaderType(): Type<ProductMenuHeaderComponent> {
    return MenuHeaderTitleImageComponent;
  }

  getShowHeader(): boolean {
    return true;
  }

  getShowFooter(): boolean {
    return false;
  }

  getShowInlineLabels(): WithinNameCell {
    return WithinNameCell.TitleLine;
  }

  getProductWrapperStyling(section: SectionWithProducts, sectionRowViewModel: SectionRowViewModel, odd: boolean) {
    const rowStyling = super.getProductWrapperStyling(section, sectionRowViewModel, odd);
    const [R, G, B] = ColorUtils.hexToRgb(this.menuOptions.bodyTextColor);
    rowStyling['border-top'] = `1px solid rgba(${R}, ${G}, ${B}, 0.5)`;
    return rowStyling;
  }

  whatFontsAreNeededToRenderContent(): FontStyleSheet[] {
    return [
      FONT.Apparat.Medium_500,
      FONT.PragmaticaExtended.Medium_500,
      FONT.Pragmatica.Regular_400,
      FONT.Pragmatica.Light_300,
      FONT.Arial.ExtraBold_800
    ];
  }

  override getAdobeFontFamilyCssUrl(): string | null {
    return 'https://use.typekit.net/ofv5kpz.css';
  }
}
